import { render, staticRenderFns } from "./ArtistPreview.vue?vue&type=template&id=69dfc7da&"
import script from "./ArtistPreview.vue?vue&type=script&lang=js&"
export * from "./ArtistPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports